import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import Delivery from '../components/Delivery'
import { productIcon } from '../helpers'
import React from 'react'
import { Page, Toolbar } from 'react-onsenui'

const EntriesByProductScreen = props => {
  const data = props.selectedEntryProduct
  let sampled = false
  return (
    <Page
      renderToolbar={() => (
        <Toolbar className={props.classes.appBar}>
          <div className="left">
            <KeyboardArrowLeftIcon onClick={() => props.goBack()} className={props.classes.goBackIcon} />
          </div>
          <div className="center">
            <Typography className={props.classes.title}>Entradas</Typography>
          </div>
          <div className="right" />
        </Toolbar>
      )}>
      <div className={props.classes.resume}>
        <Grid container spacing={16} alignItems="center">
          <Grid item xs={3}>
            <img src={productIcon(data.productIconFileName)} className={props.classes.productIcon} />
          </Grid>
          <Grid item xs={9}>
            <div>
              <Typography className={props.classes.productName}>{data.productType}</Typography>
            </div>
            <div style={{ marginTop: '-6px' }}>
              <Typography className={props.classes.productTotalKg}>
                {data.netWeightTotal.toLocaleString(undefined, { maximumFractionDigits: 2 })} kg.
              </Typography>
            </div>
            <div className={props.classes.resume2}>
              <Grid container>
                <Grid item xs={4}>
                  <div>
                    <b>{data.deliveries.length}</b>
                  </div>
                  <div style={{ marginTop: -4 }}>
                    <small>albaranes</small>
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div>
                    <b>{data.numPaletsTotal}</b>
                  </div>
                  <div style={{ marginTop: -4 }}>
                    <small>palets</small>
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div>
                    <b>{data.numBoxesTotal}</b>
                  </div>
                  <div style={{ marginTop: -4 }}>
                    <small>cajas</small>
                  </div>
                </Grid>
              </Grid>
            </div>
            {/* <Grid item>
              <span><Typography className={props.classes.productNumDeliveries}>{data.deliveries.length} albaranes</Typography></span>
            </Grid> */}
            <div item className={props.classes.filters}>
              <Typography className={props.classes.filtersText}>
                Periodo:{' '}
                <b className={props.classes.blue} dangerouslySetInnerHTML={{ __html: props.periodLabelSimple }} />
                &nbsp;&nbsp;Naves:{' '}
                <b className={props.classes.blue}>
                  {props.selectedGreenhouses.length ? `${props.greenhouses.length} seleccionadas` : 'Todas'}
                </b>
              </Typography>
            </div>
          </Grid>
        </Grid>
      </div>
      <div className={props.classes.deliveries}>
        {data.deliveries.map(delivery => {
          if (!sampled) {
            sampled = !!delivery.entries.find(e => e.sampled === true)
          }
          console.log('mapping deliveries', delivery)
          return (
            <Delivery
              key={delivery.deliveryCode}
              delivery={delivery}
              loadSampledEntryDirectAccess={props.loadSampledEntryDirectAccess}
            />
          )
        })}
      </div>
      {sampled && (
        <div className={props.classes.btSamplingsContainer}>
          <div onClick={() => props.onSelectSamplingProduct(data.productType)}>
            <Typography className={props.classes.btSamplings}>
              Ver clasificación
              <KeyboardArrowRightIcon className={props.classes.btSamplingsIcon} />
            </Typography>
          </div>
        </div>
      )}
    </Page>
  )
}

const styles = {
  appBar: {
    background: '#1B458E',
  },
  blue: {
    color: '#1B458E',
    fontWeight: 400,
  },
  goBackIcon: {
    cursor: 'pointer',
    padding: 7,
    fontSize: 30,
    color: 'white',
  },
  title: {
    padding: 10,
    fontWeight: 600,
    fontSize: 17,
    color: 'white',
    textAlign: 'center',
  },
  resume: {
    background: 'white',
    padding: '5px 10px 5px',
  },
  productIcon: {
    maxWidth: '100%',
  },
  productName: {
    fontSize: 16,
    fontWeight: 500,
    color: '#1B458E',
  },
  productTotalKg: {
    fontWeight: 'bold',
    fontSize: 30,
  },
  resume2: {
    paddingTop: 5,
    borderTop: '1px solid #DDD',
  },
  productNumDeliveries: {
    display: 'inline-block',
    background: '#8ACA4C',
    borderRadius: 5,
    color: 'white',
    padding: '2px 7px',
  },
  filters: {
    marginTop: 5,
    borderTop: '1px solid #DDD',
    paddingTop: 3,
  },
  filtersText: {
    fontWeight: 300,
    fontSize: 12,
    color: '#53535',
  },
  deliveries: {},
  btSamplingsContainer: {
    padding: 15,
  },
  btSamplings: {
    position: 'relative',
    padding: 5,
    fontSize: 16,
    backgroundColor: '#1B458E',
    color: 'white',
    borderRadius: 3,
    textAlign: 'center',
    cursor: 'pointer',
  },
  btSamplingsIcon: {
    position: 'absolute',
    top: 5,
    right: 0,
    color: 'white',
  },
}

export default withStyles(styles)(EntriesByProductScreen)



// WEBPACK FOOTER //
// ./src/screens/EntriesByProductScreen.js